// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueClipboard from 'vue-clipboard2'
import axios from "axios"
import VueAxios from "vue-axios"
import { Icon } from 'vant'
import { Popup } from 'vant'
import { Loading } from 'vant'
import { Overlay } from 'vant'
import { Cascader } from 'vant'
import { Field } from 'vant'
import { Toast } from 'vant'
import { Collapse, CollapseItem } from 'vant'
import { Dialog } from 'vant'
import { Tab, Tabs } from 'vant';
import emailtext from '@/components/emailtext.vue'
import headerimg from '@/components/headerimg.vue'

VueClipboard.config.autoSetContainer = true

Vue.use(Tab);
Vue.use(Tabs);
Vue.use(VueAxios, axios)
Vue.use(VueClipboard)
Vue.use(Icon)
Vue.use(Popup)
Vue.use(Loading)
Vue.use(Overlay)
Vue.use(Cascader)
Vue.use(Field)
Vue.use(Toast)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Dialog)
Vue.config.productionTip = false
  axios.defaults.baseURL="/"
//axios.defaults.baseURL="http://paytest.damozan.com/"
 Vue.component('emailtext',emailtext)
 Vue.component('headerimg',headerimg)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js